'use client';

import CategoryPage from '@/components/consumer/CategoryPage';
import WarehouseIdHydrator from '@/global-state/warehouseIdForUser/WarehouseIdHydrator';

export default function CategoryPageClient({
  serverCategoryData,
  serverWarehouseId,
  algoliaUserToken,
  serverSeoResolved = true,
  algoliaAnalyticsParams,
}) {
  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <CategoryPage
        serverCategoryData={serverCategoryData}
        algoliaUserToken={algoliaUserToken}
        serverSeoResolved={serverSeoResolved}
        algoliaAnalyticsParams={algoliaAnalyticsParams}
      />
    </WarehouseIdHydrator>
  );
}
